import EntityTypes from './EntityTypes'

export default EntityTypes
